/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDTOFromJSON, UserDTOToJSON, } from './UserDTO';
/**
 * @export
 */
export const ProductPoolResponseDTOTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Extension: 'EXTENSION'
};
/**
 * @export
 */
export const ProductPoolResponseDTOLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the ProductPoolResponseDTO interface.
 */
export function instanceOfProductPoolResponseDTO(value) {
    return true;
}
export function ProductPoolResponseDTOFromJSON(json) {
    return ProductPoolResponseDTOFromJSONTyped(json, false);
}
export function ProductPoolResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'asins': json['asins'] == null ? undefined : json['asins'],
        'user': json['user'] == null ? undefined : UserDTOFromJSON(json['user']),
        'type': json['type'] == null ? undefined : json['type'],
        'location': json['location'] == null ? undefined : json['location'],
        'autoCreateSearch': json['autoCreateSearch'] == null ? undefined : json['autoCreateSearch'],
        'asinCount': json['asinCount'] == null ? undefined : json['asinCount'],
        'bannedCount': json['bannedCount'] == null ? undefined : json['bannedCount'],
    };
}
export function ProductPoolResponseDTOToJSON(json) {
    return ProductPoolResponseDTOToJSONTyped(json, false);
}
export function ProductPoolResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'asins': value['asins'],
        'user': UserDTOToJSON(value['user']),
        'type': value['type'],
        'location': value['location'],
        'autoCreateSearch': value['autoCreateSearch'],
        'asinCount': value['asinCount'],
        'bannedCount': value['bannedCount'],
    };
}
